import { render, staticRenderFns } from "./WysiwygNode.vue?vue&type=template&id=6e0c5e94&"
import script from "./WysiwygNode.vue?vue&type=script&lang=js&"
export * from "./WysiwygNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports